function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(247, 247, 247)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'7a5b2342133a0cfbb741f672ea2ec5e3': 'url("//www.projectrepat.com/cdn/shop/files/pr-swatch-navy-blue_68x.jpg?v=16060615215957047641")','93b1453c8ec5a548389c935052536ccb': 'url("//www.projectrepat.com/cdn/shop/files/pr-swatch-orchid_68x.jpg?v=5819255446474543300")','3862d0eebdcfc3df1491dd4f599f7257': 'url("//www.projectrepat.com/cdn/shop/files/pr-swatch-light-blue_68x.jpg?v=3692564065546644350")','cda7a650c5856cf2f6738072447d7825': 'url("//www.projectrepat.com/cdn/shop/files/pr-swatch-gray_68x.jpg?v=10141672820799472487")','bda9643ac6601722a28f238714274da4': 'url("//www.projectrepat.com/cdn/shop/files/pr-swatch-red_68x.jpg?v=685899024211660313")','1ffd9e753c8054cc61456ac7fac1ac89': 'url("//www.projectrepat.com/cdn/shop/files/pr-swatch-black_68x.jpg?v=16093035316343169644")','9f27410725ab8cc8854a2769c7a516b8': 'url("//www.projectrepat.com/cdn/shop/files/pr-swatch-green_68x.jpg?v=18402171354450109644")','7b8263a70ff0e7ac2a3271989aa1275c': 'url("//www.projectrepat.com/cdn/shop/files/pr-swatch-lieutenant_68x.png?v=12277179270989226316")','9d430b5dd5e079588128e07ea769ae07': 'url("//www.projectrepat.com/cdn/shop/files/pr-swatch-heather-grey_68x.png?v=10200927547185126322")','f2a1cbee1fd21c1cb2c5178fc604ba2c': 'url("//www.projectrepat.com/cdn/shop/files/pr-swatch-sea-blue_68x.png?v=2983745977634142550")',};
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) swatch.style.setProperty('--tick-color', '#000');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
